import { api } from "./api";

export function pushSupported() {
  return "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;
}

function urlB64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = window.atob(base64);
  const arr = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) arr[i] = raw.charCodeAt(i);
  return arr;
}

async function reg() {
  return navigator.serviceWorker.ready;
}

export async function getPushStatus() {
  if (!pushSupported()) return { supported: false, enabled: false, permission: "default" };
  const r = await reg();
  const sub = await r.pushManager.getSubscription();
  return { supported: true, enabled: !!sub, permission: Notification.permission };
}

export async function enablePush() {
  if (!pushSupported()) throw new Error("Questo browser non supporta le notifiche push");
  const perm = await Notification.requestPermission();
  if (perm !== "granted") throw new Error("Permesso notifiche negato dal dispositivo");
  const { data } = await api.get("/push/vapid-public-key");
  const r = await reg();
  let sub = await r.pushManager.getSubscription();
  if (!sub) {
    sub = await r.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlB64ToUint8Array(data.key),
    });
  }
  await api.post("/push/subscribe", { subscription: sub.toJSON ? sub.toJSON() : sub });
  return true;
}

export async function disablePush() {
  const r = await reg();
  const sub = await r.pushManager.getSubscription();
  if (sub) {
    await api.post("/push/unsubscribe", { subscription: sub.toJSON ? sub.toJSON() : sub }).catch(() => {});
    await sub.unsubscribe();
  }
}

export async function testPush() {
  await api.post("/push/test");
}
